import authReducer from "./auth_reducer";
import { combineReducers } from "redux";
import organizationReducer from "./organization/org_reducer";
import trainingReducer from "./learning_provider/training_reducer";
import trainingUserReducer from "./learning_provider/training_user_reducer";
import puTrainingReducer from "./learning_provider/provider_user/pu_training_reducer";
import adminOrgReducer from "./admin/admin_org_reducer";
import orgTrainingReducer from "./organization/org_training_reducer";
import homeReducer from "./home/home_reducer";
import dashboardReducer from "./learning_provider/dashboard_reducer";
import adminUsersReducer from "./admin/admin_users";
import conferanceReducer from "./conferance_reducer";
import courseReducer from "./course/course_reducer";
import gcReducer from "./gogole_cloud/gc_reducer";
import certificationReducer from "./admin/certification/caertification_reducer";
import certificationMasterReducer from "./admin/certification/caertification_master_reducer";
import trainingCourseReducer from "./admin/certification/training_course_reducer";
import trainingModuleReducer from "./admin/certification/training_module_reducer";
import trainingTopicReducer from "./admin/certification/training_topic_reducer";
import categoryReducer from "./admin/certification/category_reducer";
import userProfileReducer from "./learning_provider/user_profile_reducer";
import cartReducer from "./home/cart_reducer";
import assignCourseReducer from "./course/assign_course_reducer";
import trainerReducer from "./admin/trainer/trainer_reducer";
import trainerProfileReducer from "./trainer/trainer_profile_reducer";
import trainerSkillReducer from "./trainer/trainer_skill_reducer";
import bankDetailsReducer from "./trainer/bank_details_reducer";
import trainerCertificateReducer from "./trainer/trainer_certificate_reducer";
import trainerReferenceReducer from "./trainer/trainer_reference_reducer";
import assignTrainerReducer from "./trainer/assign_trainer_reducer";
import trainingSyllabusReducer from "./learning_provider/training_syllabus_reducer";
import questionBankReducer from "./learning_provider/question/question_bank_reducer";
import serviceReducer from "./admin/service/service_reducer";

const rootReducer = combineReducers({
  authReducer: authReducer,
  adminOrgReducer: adminOrgReducer,
  orgTrainingReducer: orgTrainingReducer,
  organizationReducer: organizationReducer,
  trainingReducer: trainingReducer,
  trainingUserReducer: trainingUserReducer,
  puTrainingReducer: puTrainingReducer,
  homeReducer: homeReducer,
  dashboardReducer: dashboardReducer,
  adminUsersReducer: adminUsersReducer,
  conferanceReducer: conferanceReducer,
  courseReducer: courseReducer,
  gcReducer: gcReducer,
  categoryReducer: categoryReducer,
  certificationReducer: certificationReducer,
  certificationMasterReducer: certificationMasterReducer,
  trainingCourseReducer: trainingCourseReducer,
  trainingModuleReducer: trainingModuleReducer,
  trainingTopicReducer: trainingTopicReducer,
  userProfileReducer: userProfileReducer,
  cartReducer: cartReducer,
  assignCourseReducer: assignCourseReducer,
  trainerReducer: trainerReducer,
  trainerProfileReducer: trainerProfileReducer,
  trainerSkillReducer: trainerSkillReducer,
  bankDetailsReducer: bankDetailsReducer,
  trainerCertificateReducer: trainerCertificateReducer,
  trainerReferenceReducer: trainerReferenceReducer,
  assignTrainerReducer:assignTrainerReducer,
  trainingSyllabusReducer:trainingSyllabusReducer,
  questionBankReducer:questionBankReducer,
  serviceReducer:serviceReducer,
});

export default rootReducer;
